<div class="survey-job-header">
    <!-- Group 1: Job name and status -->
    <div class="survey-job-header-title-wrapper">
        <h4 class="survey-job-header-title job-detail-title">{{ job.name }}</h4>
        <job-status-badge [status]="job.status" />
    </div>

    <!-- Group 2: Description -->
    <div class="survey-job-header-description">
        <span class="survey-job-header-description-text">{{ job.description || '-' }}</span>
    </div>

    <!-- Group 3: Created by -->
    <div class="survey-job-header-createdby">
        <span class="survey-job-header-createdby-label survey-job-header-label">Created by</span>
        <span class="survey-job-header-createdby-value">
            {{ job.createdBy?.name || job.createdBy || '-' }}
            <ng-container *ngIf="job.createdDateTime"> on {{ job.createdDateTime | date:'dd MMM yyyy' }}</ng-container>
        </span>
    </div>

    <!-- Group 4: Last updated and Features in Job together -->
    <div class="survey-job-header-lastupdated-features-group">
        <div class="survey-job-header-lastupdated">
            <span class="survey-job-header-lastupdated-label survey-job-header-label">Last updated</span>
            <span class="survey-job-header-lastupdated-value">
                {{ job.modifiedDateTime | date:'d MMM yyyy' : '-' }}
            </span>
        </div>
        <div class="survey-job-header-features">
            <span class="survey-job-header-features-label survey-job-header-label">Features In Job</span>
            <span class="survey-job-header-features-value">
                <i class="icon_solid_clipboard_24 mixin-icon-24"></i>
                <ng-container *ngIf="totalFeatureCount != null; else loading">
                    {{ totalFeatureCount || "-" }}
                </ng-container>
                <ng-template #loading>
                    <loading />
                </ng-template>
            </span>
        </div>
    </div>
</div>
